export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6283.cb2abd10.jpg";